import React from "react";
import { useForm, Controller } from "react-hook-form";
import { Collapse, Button, Card, CardBody, CardHeader, CardFooter, Badge,Input, InputGroup, Label, Form, FormGroup,CustomInput, Row, Col, FormText } from 'reactstrap';
import AudioPreviewPlayer from "./AudioPreviewPlayer";
import {Link} from 'react-router-dom'

const NewForm = (props) => {
  const { handleSave } = props;
  const accept = ['audio/mp3', 'audio/mpeg']

  const {
    register,
    setValue,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm();

  const handleDurationChanged = (seconds) => {
    setValue('duration', seconds)
  }

  const handleRemoveFileClicked = () => {
    setValue('file', null);
    setValue('duration', 0)
  }

  const file = watch("file");
  const { ref, ...registerDescription } = register('description');

  return (
    <Form onSubmit={handleSubmit(handleSave)}>
      <Card>
        <CardHeader>
          New File
        </CardHeader>
        <CardBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="title">Name</Label>
                <InputGroup>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Intro..."
                    {...register("title", {required: true})} />
                </InputGroup>
                {errors.title && <FormText color="danger">Name can't be empty</FormText>}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {
                file && file[0] && <AudioPreviewPlayer
                  url={URL.createObjectURL(file[0])}
                  title={file[0]['name']}
                  handleDurationChanged={handleDurationChanged}
                >
                  <div className='btn btn-danger btn-sm' onClick={handleRemoveFileClicked}>
                    <span className="fe fe-trash"/> Delete
                  </div>
                </AudioPreviewPlayer>
              }
              {!(file && file[0]) && <FormGroup>
                  <input
                    type="file"
                    accept={accept.join(",")}
                    id="audiopicker"
                    name="audio file picker"
                    {...register("file", {required: true})}
                  />
                </FormGroup>
              }
              {errors.file && <FormText color="danger">File can't be empty</FormText>}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="description">Description</Label>
                <InputGroup>
                  <Input type="textarea" name="description" id="description" innerRef={ref} {...registerDescription}/>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
        <CardFooter>
          <div style={{display: "flex", flexDirection: "row-reverse"}}>
            <div style={{display: 'flex', gap: "10px", flexDirection: "row-reverse"}}>
              <Button color="primary">Save</Button>
              <Link className='btn btn-secondary' to="/dynamic-contents">Cancel</Link>
            </div>
          </div>
        </CardFooter>
      </Card>
    </Form>
  )
}

export default NewForm;